import styled from 'styled-components';

import { Copy, Headline } from '@/components/elements';
import { focusWithinStyleDark, fullsizePseudo } from '@/components/utils';

export const StyledHeadline = styled(Headline)`
  margin: var(--distance-static-s) 0 0;
  color: currentColor;
`;

export const StyledCopy = styled(Copy)`
  align-self: flex-start;
  color: var(--color-text-dark-subdued);
`;

export const StyledLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  color: currentColor;

  @media (hover: hover) {
    &:hover {
      color: currentColor;
    }
  }

  &:focus {
    outline: none;
  }

  ${fullsizePseudo};
`;

export const StyledTeaser = styled.article`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: var(--distance-static-m);
  height: 100%;
  background-color: var(--color-surface-light);
  box-shadow: var(--shadow-xs);
  border-radius: var(--border-radius-s);
  color: var(--color-link-pimary);
  box-sizing: border-box;

  @media (hover: hover) {
    &:hover {
      outline: var(--distance-static-xxs) solid var(--color-surface-light);
      box-shadow: var(--shadow-m);
      border-radius: 0;
      color: var(--color-link-pimary-hover);
    }
  }

  ${focusWithinStyleDark};

  &:active {
    outline: var(--distance-static-xxs) solid var(--color-separator-light);
    background-color: var(--color-surface-light-subdued);
    box-shadow: var(--shadow-xs);
    border-radius: 0;
    color: var(--color-link-pimary-active);
  }
`;

export const StyledRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-grow: 1;
`;
